import { createSlice } from '@reduxjs/toolkit';

const scenarioSlice = createSlice({
    name: 'scenarios',
    initialState: {
        scenarioList: [],
        selectedScenario: '',
    },
    reducers: {
        setScenarios: (state, action) => {
            state.scenarioList = action.payload;
        },
        selectScenario: (state, action) => {
            state.selectedScenario = action.payload;
        },
    },
});

export const { setScenarios, selectScenario } = scenarioSlice.actions;

export const selectScenarioList = (state) => state.scenarios.scenarioList;
export const selectCurrentScenario = (state) => state.scenarios.selectedScenario;

export default scenarioSlice.reducer;